import { z } from 'zod';
/**
 * Une étiquette lisible par un humain, telle qu'un formulaire la rend : **le vide est `null`, pas
 * la chaîne vide**.
 *
 * ⚠️ Ce n'est pas de la cosmétique. Un champ de saisie non rempli donne `''`, et `''` stocké tel
 * quel fabriquerait une valeur *qui existe* — affichée vide dans la colonne, distincte de `null`
 * au `concat_ws` d'une recherche, et comptée comme un doublon par la prochaine. Les colonnes sont
 * nullables (M1) : c'est `null` qui veut dire « pas renseigné ».
 *
 * ⚠️ **Il replie, il ne refuse pas** (M21) : une valeur à espaces superflus est une faute de
 * frappe, pas une saisie à rejeter.
 *
 * ⚠️ **`nullish` et non `nullable` : la clé absente vaut « pas renseigné ».** Un champ facultatif
 * dont l'omission rend `400` refuse pour une valeur qui ne porte aucune information — relevé sur
 * l'API réelle, `{"reference":"X"}` seul y prenait un refus nommant `caseReference`. Le type
 * **rendu** reste `string | null` : un appelant TypeScript passe toujours les deux clés, c'est
 * l'appel HTTP direct qui gagne le droit de les taire.
 *
 * ⚠️ **Une seule déclaration pour tout le domaine**, et c'est ce qui compte : la création d'une
 * demande et celle d'un client répondent à la même question, et deux copies de cette règle
 * finiraient par ne plus replier `''` du même côté.
 */
export const freeLabelSchema = z
    .string()
    .nullish()
    .transform((text) => {
    const trimmed = text?.trim() ?? '';
    return trimmed === '' ? null : trimmed;
});
//# sourceMappingURL=free-label.js.map